// Helper
const $ = (s, r=document) => r.querySelector(s);

/* WhatsApp deep-link (يفتح التطبيق على الجوال أو الويب على الكمبيوتر) */
export function initWhatsAppDeepLink() {
  const waAnchor = $('#ctaWhatsApp');
  if (!waAnchor) return;

  waAnchor.addEventListener('click', () => {
    const url = "https://api.whatsapp.com/send/?phone=966555215107&text&type=phone_number&app_absent=0";
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      try { window.location.href = url; } catch(_) {}
    }
  });
}